'use client';

import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

const useIsDesktop = () => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up("md"));
}

export default useIsDesktop;